var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.assetInfo.id != null
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _vm._v("资产基础信息")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.title || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.title || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", { attrs: { title: _vm.assetInfo.name || "无" } }, [
                    _vm._v(_vm._s(_vm.assetInfo.name || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _vm.assetInfo.wrntDueTime != null &&
                      new Date(_vm.assetInfo.currentTime).getTime() >
                        new Date(_vm.assetInfo.wrntDueTime).getTime()
                        ? _c("span", { staticClass: "font-red" }, [
                            _vm._v("否")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.assetInfo.wrntDueTime == null ||
                      new Date(_vm.assetInfo.currentTime).getTime() <=
                        new Date(_vm.assetInfo.wrntDueTime).getTime()
                        ? _c("span", { staticClass: "font-green" }, [
                            _vm._v("是")
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.model || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.model || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.fixedSpec || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.fixedSpec || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.catName || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.catName || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _vm._l(_vm.assetInfo.tagNames, function(tagName) {
                      return [
                        _c(
                          "span",
                          { staticClass: "swb-tags swb-tags-success mr5" },
                          [_vm._v(_vm._s(tagName))]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.devcGroupFullName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.brandName || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.brandName || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.tmpNo || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.tmpNo || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.innerCode || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.innerCode || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "span",
                        { attrs: { title: _vm.assetInfo.upc || "无" } },
                        [_vm._v(_vm._s(_vm.assetInfo.upc || "无"))]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(12),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "span",
                        {
                          attrs: {
                            title: _vm.assetInfo.vendorCreditCode || "无"
                          }
                        },
                        [_vm._v(_vm._s(_vm.assetInfo.vendorCreditCode || "无"))]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(13),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "span",
                        { attrs: { title: _vm.assetInfo.vendorSn || "无" } },
                        [_vm._v(_vm._s(_vm.assetInfo.vendorSn || "无"))]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(14),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "span",
                        {
                          attrs: {
                            title: _vm.assetInfo.temperFlag ? "需要" : "不需要"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.assetInfo.temperFlag ? "需要" : "不需要")
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.temperFlag
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(15),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "span",
                        { attrs: { title: _vm.assetInfo.temperLow || "无" } },
                        [_vm._v(_vm._s(_vm.assetInfo.temperLow || "无"))]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.temperFlag
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "span",
                        { attrs: { title: _vm.assetInfo.temperHigh || "无" } },
                        [_vm._v(_vm._s(_vm.assetInfo.temperHigh || "无"))]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(17),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.assetInfo.assetKindName || "无" } },
                    [_vm._v(_vm._s(_vm.assetInfo.assetKindName || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(18),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.assetInfo.devcDefId == -1 ? "未关联" : "已关联"
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(19),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.useModeMap[_vm.assetInfo.useMode]))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(20),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.patrolFlag ? "是" : "否"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(21),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.maintFlag ? "是" : "否"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(22),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.inspectFlag ? "是" : "否"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(23),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.setupFlag ? "是" : "否"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(24),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.repairFlag ? "是" : "否"))
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed" }, [
              _vm._v("财务信息")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(25),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.acctEnterWayMap[_vm.assetInfo.acctEnterWay])
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(26),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.assetInfo.fiscalAcctFlag == 1 ? "是" : "否")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(27),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.fiscalIgnored ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(28),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.fiscalInFlag ? "是" : "否"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(29),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.assetInfo.fiscalOutFlag ? "是" : "否")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(30),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.assetIdleX ? "是" : "否"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 1
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(31),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [_vm._v(_vm._s(_vm.assetInfo.idleQuantity))])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(32),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.assetInfo.orgWorth == null
                          ? "无"
                          : _vm.assetInfo.orgWorth.toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(33),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.assetInfo.netWorth == null
                          ? "无"
                          : _vm.assetInfo.netWorth.toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(34),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.assetInfo.deprOver
                    ? _c("span", { staticClass: "font-red" }, [_vm._v("是")])
                    : _c("span", [_vm._v("否")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(35),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.rmnWorthRatio || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(36),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.durableLife || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(37),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.assetInfo.fiscalAcctFlag == 0
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.durableYears || 0))
                      ])
                    : _vm.assetInfo.deprable
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.assetInfo.durableLife -
                              _vm.assetInfo.leftMonths || 0
                          )
                        )
                      ])
                    : _c("span")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(38),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.assetInfo.receiveTime != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            new Date(_vm.assetInfo.receiveTime).format(
                              "yyyy-MM-dd HH:mm:ss"
                            )
                          )
                        )
                      ])
                    : _c("span", [_vm._v("无")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(39),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.assetInfo.currentMonthDepr != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.assetInfo.currentMonthDepr.toFixed(2))
                        )
                      ])
                    : _c("span", [_vm._v("无")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(40),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.assetInfo.aggtDeprWorth || 0).toFixed(2))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(41),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s((_vm.assetInfo.extraWorth || 0).toFixed(2)))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed" }, [
              _vm._v("库存信息")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(42),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.retailerBizUnitName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(43),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.retailerComFullName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(44),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.retailerRealComCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(45),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.retailerShopTagName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(46),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.warehouseName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(47),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.assetInfo.inStkQuantity > 0 ? "是" : "否")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 1
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(48),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetInfo.inStkQuantity || 0))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.assetInfo.assetType == 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(49),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.assetInfo.indoubtFlag == 1 ? "是" : "否")
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed" }, [
              _vm._v("管理信息")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(50),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.respblDepartFullName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(51),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.respblStaffName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(52),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.applyUseDepartFullName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(53),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.applyUseStaffName || "无"))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed" }, [
              _vm._v("合约信息")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(54),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetInfo.initContractNo || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(55),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.assetInfo.wrntStartTime != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            new Date(_vm.assetInfo.wrntStartTime).format(
                              "yyyy-MM-dd HH:mm:ss"
                            )
                          )
                        )
                      ])
                    : _c("span", [_vm._v("无")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(56),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetInfo.wrntPeriod || "0"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(57),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.assetInfo.wrntDueTime != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            new Date(_vm.assetInfo.wrntDueTime).format(
                              "yyyy-MM-dd HH:mm:ss"
                            )
                          )
                        )
                      ])
                    : _c("span", [_vm._v("无")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(58),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.assetInfo.receiveTime != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            new Date(_vm.assetInfo.receiveTime).format(
                              "yyyy-MM-dd HH:mm:ss"
                            )
                          )
                        )
                      ])
                    : _c("span", [_vm._v("无")])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.assetDtl.id != null
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _vm._v("资产清单信息")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(59),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.retailerRealComCode))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(60),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.innerCode))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(61),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.title))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(62),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.brandModel))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(63),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.assetKindName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(64),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.assetKindCode))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(65),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.costCenterCode))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(66),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.quantity))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(67),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.theUnit))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(68),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.assetDtlDateToViewModel(_vm.assetDtl.receiptDate)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(69),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.receiptInnerNo))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(70),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.assetDtlDateToViewModel(_vm.assetDtl.fiscalInDate)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(71),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.durableLife))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(72),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s((_vm.assetDtl.orgWorth || 0).toFixed(2)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(73),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s((_vm.assetDtl.aggtDeprWorth || 0).toFixed(2)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(74),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        (_vm.assetDtl.lastDeprAdjustExtraWorth || 0).toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(75),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s((_vm.assetDtl.netWorth || 0).toFixed(2)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(76),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.principalName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(77),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.useStateName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(78),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.assetNatureName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(79),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.acctEnterWayName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(80),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.acctOutWayName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(81),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.innerNo))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(82),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.assetDtl.scrappedName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(83),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetDtl.receiptVoucherTypeName))
                  ])
                ])
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产描述全称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("保内")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("型号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规格")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("维保分组")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("品牌")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("统一商品代码(UPC)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供应商编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("厂商序列号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需要控温")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("温度低值(°c)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("温度高值(°c)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务类别")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("关联定义")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用模式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需巡查")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需保养")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需检验")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需安装")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("可维修")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("入账方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务在账")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("不入账")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已入账")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已出账")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("闲置")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("闲置数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("原值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("净值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧完毕")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("残值率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用年限(月)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已用年限(月)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("首次购置")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当月折旧(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("累计折旧(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("计划外折旧(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("部门全称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("实体公司代码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("仓库名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在库数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("账面不符")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("责任部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("责任人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("领用部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("领用人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("初始合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("质保开始时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("质保期(月)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("质保到期时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司代码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("品牌型号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务类别")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务类别编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单位")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收单自有编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("入账日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用年限(月)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产原值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("累计折旧(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("计划外折旧(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产净值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("责任人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产属性")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("入账方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("出账方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("外部系统编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废/弃用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("来源方式")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cea049c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cea049c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/AssetFiscalInfo.vue
// module id = 3137
// module chunks = 0